import AxiosProvider from '@/app/utils/api/axios-provider';
import { AxiosResponse } from 'axios';
import { Role } from '@/app/shared/types/models/role.interface';

export interface PaginationParams {
  page?: number;
  size?: number;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
}

export default {
  getRoles(params?: PaginationParams): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.get('/roles', { params });
  },
  getRoleById(id: number | string): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.get(`/roles/${id}`);
  },
  createRole(role: Role): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.post('/roles', role);
  },
  updateRole(id: number | string, role: Role): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.patch(`/roles/${id}`, role);
  },
  deleteRole(id: number | string): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.delete(`/roles/${id}`);
  },
  getRolesByClientId(
    clientId: number,
    params?: PaginationParams
  ): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.get(`/roles/by-client/${clientId}`, {
      params,
    });
  },
  getRoleAccessList(): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.get('/rights');
  },
};
